import React from "react";
import CategoryPage from "./CategoryPage";

function CampusReport({ posts, publications }) {

  return (
    <CategoryPage
      title="Campus Report"
      posts={posts}
      publications={publications}
    />
  );

}

export default CampusReport;